<template>
    <div class="hotel-info-services-label" v-html="service.supplierServiceName" />
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'

    @Component
    export class HotelInfoServicesLabel extends Vue {
        @Prop({required: true}) service
    }

    export default HotelInfoServicesLabel
</script>
